'use strict';

// Constructor
var Slide3 = function () {
    $('.slide3').waypoint(function () {
        $('.slider button').removeClass('active');
        $('.slider .button_slide3').addClass('active');

        // Activate the chart
        setTimeout(function () {
            if (window.charts_collection['home-chart']) {
                window.charts_collection['home-chart'].update({
                    duration: 800,
                    lazy: false,
                    easing: 'easeOutBounce'
                });
            }
        }, 300);
    }, {
        offset: '5%'
    });

    $('.slide3').waypoint(function () {
        $('.slider button').removeClass('active');
        $('.slider .button_slide2').addClass('active');
        $('.slide3').addClass('active');
    }, {
        offset: '99%'
    });


    // If on home page then draw the chart only when canvas in focus
    if ($('main.home').length > 0) {
        setTimeout(function () {
            if (window.charts_collection['home-chart']) {
                window.charts_collection['home-chart'].reset();
            }
        }, 100);
    }
};

module.exports = Slide3;
